import type { FeatureFilters } from "@/infrastructure/repositories/features.supabase.repository";

export const featuresKeys = {
  all: ["features"] as const,
  list: (filters: FeatureFilters = {}) => [...featuresKeys.all, "list", filters] as const,
  detail: (id: string) => [...featuresKeys.all, "detail", id] as const,
};
